import { AdvancedCheckboxProps } from '../../types/global';
import { camelCase } from '../../utils/formatters';
import Tooltip from '../toolTip';

export default function AdvancedCheckbox({
  fieldsetId, fieldsetTitle, options, onChange, selected, infoBubble,
}: Readonly<AdvancedCheckboxProps>) {
  // lower case word, replace the first letter with lower case and the rest with upper case

  const multipleOptions = (checkboxOptions: string[]) => checkboxOptions.map((option: string, index: number) => (
    <label htmlFor={`${option}-${index}`} key={`${option}-checkbox`} className="flex flex-row">
      <input
        type="checkbox"
        id={`${option}-${index}`}
        name={camelCase(option)}
        checked={selected}
        onChange={onChange}
        defaultChecked={false}
      />
      <span className="pl-2">{option}</span>
    </label>
  ));

  const singleOption = (checkboxOptions: string) => (
    <label htmlFor={checkboxOptions} className="flex flex-row">
      <input
        type="checkbox"
        name={camelCase(checkboxOptions)}
        id={checkboxOptions}
        onChange={onChange}
        defaultChecked={false}

      />
      <span className="pl-2">{options}</span>
    </label>
  );
  return (
    <fieldset
      id={fieldsetId}
      className="justify-between w-full font-thin p-2"
    >
      <div className="flex flex-row space-x-2">
        <legend className="">{fieldsetTitle}</legend>
        {infoBubble ? <Tooltip label={fieldsetTitle} text={infoBubble} /> : ''}
      </div>
      {Array.isArray(options) ? multipleOptions(options) : singleOption(options)}
    </fieldset>
  );
}
